export default __webpack_public_path__ + "static/media/Aura-Egg__19.4123aa39.png";